import { cn } from '@/lib/cn';
import { ToggleTab } from './ToggleTab';
import type { ActivateFn, Translate } from './types';

export function GenericOutcomePicker({
  options,
  outcome,
  setOutcome,
  highlighted,
  onActivate,
  labelFor,
  t,
  compact = false,
}: {
  options: readonly string[];
  outcome: string;
  setOutcome: (v: string) => void;
  highlighted: boolean;
  onActivate: ActivateFn;
  labelFor: (value: string) => string;
  t: Translate;
  compact?: boolean;
}) {
  return (
    <div
      data-field-key="outcome"
      className={cn('transition-colors', highlighted && 'bg-signal-soft ring-1 ring-signal')}
      onFocusCapture={() => onActivate('outcome', 'form')}
    >
      {!compact && <span className="sr-only">{t('try.outcome')}</span>}
      <div className="flex flex-wrap gap-px">
        {options.map((opt) => (
          <ToggleTab
            key={opt}
            active={outcome === opt}
            onClick={() => {
              setOutcome(opt);
              onActivate('outcome', 'form');
            }}
          >
            {labelFor(opt)}
          </ToggleTab>
        ))}
      </div>
    </div>
  );
}
